import { Stack, Typography, Button } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { urlGetByIdWorks } from '../../helpers';
import useFetch from '../../hooks/useFetch';
import CircularProgress from '@mui/material/CircularProgress';
import './style.css';
import { ViewContactData } from './components/ViewContactData';
import ViewServiceWork from './components/ViewServiceWork';
import { ViewRentsWork } from './components/ViewRentsWork';
import { ViewConditionWork } from './components/ViewConditionWork';
import { dateFormmater } from '../../helpers';
import { ViewCertificationWork } from './components/ViewCertificationWork';

export const WorkViewData = () => {

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    
    const { data } = useFetch(urlGetByIdWorks + searchParams.get('id'));

    const { addressWork, contact, status, client, characteristics, changes, rents, product, rentAbatementDate, dateRentalEntry, dateGetMaterial, estimateId, id, dateRentalEnd } = data || {};
    const changeLineToLine = changes?.split(/\r\n|\r|\n/,-1);
    const characteristicsLineToLine = characteristics?.split(/\r\n|\r|\n/,-1);

    return (
        <Stack width='100%' alignItems='center' >
            {
                data
                    ?
                    <Stack width='95%' mt='2rem' className='viewPage' mb='2rem' >
                        <Typography variant="h4" color="primary" textAlign='center'><b>Obra:</b> {addressWork}</Typography>
                        <ViewContactData status={status} dataContact={JSON.parse(client?.contacts).filter(d => d.contactName === contact)[0]} />

                        <Typography variant="h6" color="primary" textAlign='center'>Condiciones</Typography>
                        <ViewConditionWork data={data} />

                        <Typography variant="h6" color="primary" textAlign='center'>Servicios</Typography>
                        <ViewServiceWork services={product} />

                        <Typography variant="h6" color="primary" textAlign='center'>Alquileres</Typography>
                        <ViewRentsWork rents={rents} />

                        <Typography variant="h6" color="primary" textAlign='center'>Otros</Typography>
                        <Stack >
                            {characteristics && <Typography variant='subtitle1'><b>Caracteristicas:</b> {characteristicsLineToLine.map((line, i) => <p key={i} >{'- ' +line}</p>)}</Typography>}

                            {changes && 
                            <div>
                                <Typography variant='subtitle1'><b>Modificaciones: </b></Typography>
                                {changeLineToLine.map((line, i) => <p key={i} style={{marginLeft:'135px'}}>{'- ' +line}</p>)}
                            </div>
                            }
                            {dateRentalEntry && <Typography variant='subtitle1'><b>Fecha de alta del alquiler: </b> {dateFormmater(dateRentalEntry)}</Typography>}
                            {dateRentalEnd && <Typography variant='subtitle1'><b>Fecha de baja del alquiler: </b> {dateFormmater(dateRentalEnd)}</Typography>}
                            {rentAbatementDate && <Typography variant='subtitle1'><b>Fecha de desmontaje de material: </b> {dateFormmater(rentAbatementDate)}</Typography>}
                            {dateGetMaterial && <Typography variant='subtitle1'><b>Fecha de recogida de material: </b> {dateFormmater(dateGetMaterial)}</Typography>}
                        </Stack>

                        <Typography variant="h6" color="primary" textAlign='center'>Certificaciones</Typography>
                        <ViewCertificationWork workId={id}/>

                        <Link to={`/viewEstimate?id=${estimateId}`} style={{ textDecoration: 'none', textAlign: 'center' }}><Button variant='outlined' color="primary" >Ver Presupuesto de origen</Button></Link>
                    </Stack>
                    : <CircularProgress />
            }
        </Stack>
    )
}
